import React from 'react';
import { Link } from 'react-router-dom';
import './QuickLinks.css';
import CustomLinks2 from "../CustomLink/CustomLink2";

const QuickLinks = ({ links, Title }) => {
  return (
    <div className="QuickLinks-container">
      
      <ul className="QuickLinks-list">
      <h1 className="QuickLinks-title">{Title}</h1>
        {links.map((link, index) => (
          <li key={index} className="QuickLinks-item">
            
              {link.icon && <img src={link.icon} alt={`${link.name} icon`} className="QuickLinks-icon" />}
              {/* <span>{link.name}</span> */}
              <CustomLinks2 key={index} link={link.url} linktext={link.name} />
          </li>
        ))}
      </ul>
    </div>
  );
};

export default QuickLinks;
